<template>
    <div class="tw:relative tw:flex tw:items-center tw:w-full">
        <!-- Icono a la izquierda (Prefix) -->
        <div v-if="prefixIcon"
            class="tw:absolute tw:left-4 tw:text-slate-400 tw:flex tw:items-center tw:pointer-events-none">
            <i :class="prefixIcon"></i>
        </div>

        <input
            class="tw:block tw:w-full tw:py-2 tw:bg-slate-50/70 tw:border tw:border-slate-200 tw:rounded-xl tw:text-sm tw:text-slate-800 tw:placeholder:text-slate-400 tw:focus:ring-2 tw:focus:ring-primary/20 tw:focus:border-primary tw:transition-all tw:outline-none tw:disabled:bg-slate-100 tw:disabled:border-slate-200 tw:disabled:text-slate-400"
            :class="[
                prefixIcon ? 'tw:pl-11' : 'tw:pl-4',
                suffixIcon || $slots.suffix ? 'tw:pr-11' : 'tw:pr-4'
            ]" :type="type" :value="value" :placeholder="placeholder" :disabled="disabled" :required="required"
            :step="step" v-bind="$attrs" v-on="inputListeners" />

        <!-- Icono a la derecha (Suffix) -->
        <div v-if="suffixIcon || $slots.suffix" class="tw:absolute tw:right-4 tw:text-slate-400 tw:flex tw:items-center"
            :class="{ 'tw:pointer-events-none': !$slots.suffix }">
            <slot name="suffix">
                <i :class="suffixIcon"></i>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseInput',
    inheritAttrs: false,
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        step: {
            type: [Number, String],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        prefixIcon: {
            type: String,
            default: '' // Ejemplo: 'fas fa-envelope'
        },
        suffixIcon: {
            type: String,
            default: '' // Ejemplo: 'fas fa-check'
        }
    },
    computed: {
        // Reenvía al <input> los listeners del padre (@keyup, @change, @blur, ...);
        // `input` se reemplaza para que v-model reciba el valor y no el evento nativo.
        inputListeners() {
            return {
                ...this.$listeners,
                input: event => this.$emit('input', event.target.value),
            };
        }
    }
}
</script>